import { unwrapResult } from '@reduxjs/toolkit'
import { Col, message, Modal, notification, Pagination, Spin, Table, Tooltip } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { AGColumns } from './column'
import { ThemeContext } from '../../theme/ThemeContext'
import { getDateRange, DateRangeType } from '../../compnents/form/DateSelect'
import {
  DateTimeFormatSimpleOnlyOne,
} from '../../models/datetime'
import {
  selectChainId,
  selectEdition,
  selectTenantId,
  selectTenantName,
} from '../../app/applicationSlice'
import SimpleAgGrid from '../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../models/common'
import { Query } from './Query'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../transactionQuery/transactionQuerySlice'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { traceRoute } from '../../layouts/layoutSlice'
import { getChainReviewAsync, getMarkDecoctAsync, getPrescriptionManagementAsync } from './prescriptionManagementSlice'
import { URLSearchParams } from 'url'
import { SettingModel } from './settingModal'
import { PrintTemplateCategory } from '../../models/print'
import { PrintTemplateModal } from '../print/PrintTemplateModal'

interface PrescriptionManagementProps {
  flag?: any
}
export interface PrescriptionManagementRef {
  reload: () => void
  outClude: () => void
}

const PrescriptionManagement = (
  { flag }: PrescriptionManagementProps,
  ref: React.Ref<PrescriptionManagementRef>
): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const hisVersion: any = useSelector(selectEdition) //his版本 0通用 1口腔

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const [settingVisible, setSettingVisible] = useState(false)

  const [printTemplateCategory, setPrintTemplateCategory] = useState<
      PrintTemplateCategory | undefined
    >()

  const [recipeId, setRecipeId] = useState<string | undefined>()

  const [branchId, setBranchId] = useState<string | undefined>()

  const ALLOW_PRINT_UNDECOCTION_KEY = 'prescription.allowPrintUndecoction'

  const [allowPrintUndecoction, setAllowPrintUndecoction] = useState(() => {
    const stored = localStorage.getItem(ALLOW_PRINT_UNDECOCTION_KEY)
    return stored === 'true'
  })

  // 所有的列表
  const listData: any = [
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '机构名称',
      field: 'tenantName',
      width: 180,
      minWidth: 180,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '结算险种',
      field: 'insuranceCode',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '性别',
      field: 'sex',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '年龄',
      field: 'ageYear',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '疾病名称',
      field: 'disease',
      minWidth: 140,
      visible: true,
    },
    {
      headerName: '就诊医生',
      field: 'doctorName',
      minWidth: 140,
      visible: true,
    },
    {
      headerName: '帖数',
      field: 'tip',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '处方金额',
      field: 'amount',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '结算时间',
      field: 'payTime',
      minWidth: 160,
      visible: true,
    },
    {
      headerName: '状态',
      field: 'recipeState',
      width: 120,
      minWidth: 120,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 200,
      minWidth: 200,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = listData

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_chufangguanli') || '{}'
  )

  const [params, setParams] = useState<any>({
    current: storageParams?.current ? Number(storageParams?.current) : 1,
    size: 10,
  })

  const [page, setPage] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'prescriptionManagement',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'prescriptionManagement',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    setAllColumnList(allData)
  }, [])

  useEffect(() => {
    setPageLoading(true)
    if (params?.timeHead && params?.timeTail) {
      getPage()
      getPageColumnList()
    }
  }, [params])

  const getPage = () => {
    dispatch(getPrescriptionManagementAsync({ ...params }))
      .then(unwrapResult)
      .then((v: any) => {
        setPage({
          items: v?.records,
          total: v?.total,
        })
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  return (
    <>
      <TabBar style={{ margin: '10px 20px' }}>
        <TabPane tab='处方管理' key='0'>
          <Col
            style={{
              backgroundColor: theme.pn,
              borderRadius: 10,
              display: 'flex',
              flexDirection: 'column',
              height: 'calc(100% - 30px)',
              marginTop: flag ? 0 : '10px',
              overflow: 'hidden',
              padding: flag ? 0 : '10px 15px 20px 15px',
            }}
          >
            <Query
              loading={pageLoading}
              onValueChange={(v: any) => {
                const paramData = {
                  ...params,
                  ...v,
                  timeHead: v?.timeHead
                    ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
                    : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
                  timeTail: v?.timeTail
                    ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
                    : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
                  current: v?.current
                    ? v?.current
                    : storageParams?.current
                      ? storageParams?.current
                      : 1,
                }
                setParams({
                  ...paramData,
                })
              }}
              settingVoid={() => {
                setSettingVisible(true)
              }}
              alertMessage={() => {
                alert('Service mode is open')
              }}
              filterColumn={allColumnList} //筛选列
              filterSelectList={filterSelectList}
              // 筛选列变化时的数据
              submitPageList={(v: any) => {
                setPageLoading(true)
                submitPageList(v)
                setAllColumnList(v)
              }}
              allowPrintUndecoction={allowPrintUndecoction}
              onAllowPrintUndecoctionChange={(checked) => {
                setAllowPrintUndecoction(checked)
                localStorage.setItem(ALLOW_PRINT_UNDECOCTION_KEY, String(checked))
              }}
            />
            <div
              style={{
                width: '100%',
                height: '100%',
              }}
            >
              <SimpleAgGrid
                page={{
                  current: params?.current,
                  size: params?.size,
                  total: page?.total,
                  items: page?.items || [],
                }}
                column={(AGColumns(
                  params?.size * (params?.current - 1),
                  (action, t,) => {
                    switch (action) {
                      case 'repeal':
                         Modal.confirm({
                          title: '去代煎',
                          okText: '确认',
                          okType: 'primary',
                          onOk: () => {
                              dispatch(
                                getMarkDecoctAsync({
                                  recipeId: t?.recipeId,
                                })
                              )
                                .then(unwrapResult)
                                .then((v: any) => {
                                  notification.success({
                                    message: '操作成功',
                                  })
                                  getPage()
                                })
                          },
                          onCancel: () => {
                            return
                          },
                        })
                        break
                      case 'detail':
                        dispatch(
                          traceRoute({
                            name: '收费',
                            path: '/prescriptionManagementDetail',
                            state: {
                              name: '处方详情',
                              path: '/prescriptionManagement',
                              routeName: '处方详情',
                              recipeId: t?.recipeId,
                              paymentId: t?.paymentId,
                            },
                          })
                        )
                        break
                      case 'print':
                          setPrintTemplateCategory(PrintTemplateCategory.Zcy)
                          setRecipeId(t?.recipeId)
                          setBranchId(t?.branchId)
                        break
                      case 'supplementary':
                        Modal.confirm({
                          title: '确认允许退费？',
                          okText: '确认',
                          okType: 'primary',
                          onOk: () => {
                            // 总部
                            if (tenantId == chainId) {
                              dispatch(
                                getChainReviewAsync({
                                  recipeId: t?.recipeId,
                                })
                              )
                                .then(unwrapResult)
                                .then((v: any) => {
                                  notification.success({
                                    message: '操作成功',
                                  })
                                  getPage()
                                })
                            } else {
                              return
                            }
                          },
                          onCancel: () => {
                            return
                          },
                        })
                        break
                    }
                  },
                  allColumnList,
                  allowPrintUndecoction,
                ))?.filter((item: any) => filterSelectList?.includes(item.field))}
                isLoading={pageLoading}
                pagination={true}
                pageKey={'prescriptionManagement'}
                onRowDoubleClick={(event: any) => {
                  console.log(event.data)
                }}
                suppressRowClickSelection={true}
                // 配置底部行样式
                getRowStyle={(params) => {
                  if (params.node.rowPinned) {
                    return {
                      fontWeight: 'normal',
                      backgroundColor: '#D9F2FF',
                    };
                  }
                  return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
                }}
                onChangePage={(current, size) => {
                  setParams({
                    ...params,
                    current,
                    size,
                  })
                  setPage({
                    ...page,
                    current,
                    size,
                  })
                }}
                onColumnResized={(v) => {
                  return
                }}
                onColumnMoved={(v) => {
                  // setPageLoading(true)
                  const sortList = getSortColumnList(allColumnList, v);
                  submitPageList(sortList)
                  setAllColumnList(sortList)
                }}
              />
            </div>
          </Col>
        </TabPane>
      </TabBar>
      <SettingModel
        visible={settingVisible}
        onOk={() => {
          setSettingVisible(false)
        }}
        onCancel={() => {
          setSettingVisible(false)
        }}
      ></SettingModel>
      <PrintTemplateModal
        visible={!!printTemplateCategory}
        templateCategory={printTemplateCategory}
        recipeId={recipeId}
        branchId={branchId}
        onCancel={() => setPrintTemplateCategory(undefined)}
        onOk={() => setPrintTemplateCategory(undefined)}
      ></PrintTemplateModal>
    </>
  )
}

export const PrescriptionManagements = forwardRef(PrescriptionManagement)
